import React from 'react';
import { useModal } from 'core/modules/Modal/ModalProvider';
import { useSelector } from 'react-redux';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { DaysToExpire, Logo } from 'core/modules/Instore2/partials';
import InstoreOfferLink from './components/InstoreOfferLink/InstoreOfferLink';
import OfferRebate from './components/OfferRebate/OfferRebate';

import './InstoreOfferTile.scss';

function InstoreOfferTile({ offer, namespace, shouldUseDesktopTileOnMobile }) {
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const { openModal } = useModal();
  const { offerId, rclonMerchantName, carteraMerchantId } = offer;

  const openInstoreOfferModal = () => {
    openModal({
      name: 'mt_instoreOffer2',
      params: { offerId, namespace },
    });
  };

  const attributes = {
    'data-gmid': carteraMerchantId,
    'data-merchant-name': rclonMerchantName,
    'data-offer-id': offerId,
  };

  if (isMobileMQ && !shouldUseDesktopTileOnMobile) {
    return (
      <div
        className="mn_instoreOfferTile mn_mobile"
        onClick={openInstoreOfferModal}
        role="button"
        tabIndex={0}
        {...attributes}
      >
        <div className="mn_leftSection">
          <Logo offer={offer} />
          <OfferRebate offer={offer} />
        </div>
        <div className="mn_rightSection">
          <InstoreOfferLink offer={offer} namespace={namespace} />
          <DaysToExpire offer={offer} />
        </div>
      </div>
    );
  }

  return (
    <div
      className="mn_instoreOfferTile mn_desktop"
      onClick={openInstoreOfferModal}
      role="button"
      tabIndex={0}
      {...attributes}
    >
      <div className="mn_topSection">
        <Logo offer={offer} />
      </div>
      <div className="mn_bottomSection">
        <OfferRebate offer={offer} />
        <InstoreOfferLink offer={offer} namespace={namespace} />
        <DaysToExpire offer={offer} />
      </div>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><InstoreOfferTile {...props} /></ComponentErrorBoundary>;
